export const TESTED_ORIGINAL_CASE_LABELS = new Set([
  'Студия выставлена на продажу',
  'Студия нет продаж',
  'Студия закрыта',
  'Франчайзи бывший',
  'Студия приостановлена',
  'Абонементы -> микс',
])

export function isOriginalCaseTested(label: string) {
  return TESTED_ORIGINAL_CASE_LABELS.has(label.trim())
}
